import React, { useEffect, useState } from "react";
import axios from "axios";
import { getUrl } from "../../MIS/Global";
import { Button } from "react-bootstrap";
import ButtonEL from "../GlobalComponent/Elements/ButtonEL";
import Select from "react-select";
import { handleMainCategory_Get, handleSubProduct_Get, handleSubmit_subProduct } from "./subProductDraggModel";

const SubProductDraggableList = () => {
  const apiClient = axios.create({
    baseURL: getUrl(),
    headers: { "Content-Type": "application/json" },
  });

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState([]);
  const [isChanged, setIsChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);  
  const [selectedOption, setSelectedOption] = useState(null);
    
  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    if (dragIndex === dropIndex) return;

    const updatedItems = [...items];
    const draggedItem = updatedItems.splice(dragIndex, 1)[0];
    updatedItems.splice(dropIndex, 0, draggedItem);

    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      seqno: index,
    }));    
    setItems(reorderedItems);
    setIsChanged(true);
  };
   
  useEffect(() => {    
    handleMainCategory_Get({setCategoryOptions,setSelectedOption})
  },[]);

  useEffect(() => {    
    if (selectedOption && 'value' in selectedOption) {
      handleSubProduct_Get({setItems,selectedOption,setLoading})
    }
  },[selectedOption]);

  return (
    <div className="container mt-4">    
      <style>
        {`
        .draggable-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 12px;
        }

        .draggable-item {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 12px;
          cursor: grab;
          transition: transform 0.2s, background 0.3s;
          user-select: none;
          border: 1px solid #ddd;
          border-radius: 8px;
          background: #fff;
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
          text-align: center;
        }

        .draggable-item:hover {
          background: #f8f9fa;
          transform: scale(1.05);
        }

        .save-btn {
          margin-top: 15px;
          width: 100%;
        }
        `}
      </style>

      {/* Header Section with Select */}
      <div className='d-flex mb-4'>
        <h4 className="text-center flex-grow-1 m-0">Drag & Reorder Sub Product</h4>
      </div>
      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
        <div style={{ minWidth: "250px", flex: "1" }}>
          <Select
            options={categoryOptions}
            value={selectedOption}
            onChange={(option) => setSelectedOption(option)}
            placeholder="Filter Category"
            isClearable
          />
        </div>
        
      </div>

      <div className="draggable-grid">
        {loading === true ? (
          <div className="d-flex align-items-center justify-content-center w-100" style={{ gridColumn: '1/-1', minHeight: '100px' }}>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </div>
        ) : (
          items.map((item, index) => (
            <div
              key={item.id}
              className="draggable-item"
              draggable
              onDragStart={(e) => handleDragStart(e, index)}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, index)}
            >
              {item?.subpname}
            </div>
          ))
        )}
      </div>

      {isChanged && (
        <ButtonEL
          type="button"
          variant="primary"
          isLoading={isLoading}
          loadingText="Saving..."
          className="save-btn"
          onClick={()=>{handleSubmit_subProduct({items,setIsLoading,setIsChanged})}}
        >
          Save Order
        </ButtonEL>
      )}
    </div>
  );
};

export default SubProductDraggableList;
